module.exports = __webpack_public_path__ + "static/media/asset_3.f6dadbd1.png";